import { CustomerInterfaceState, initialCustomerState } from '../state/customer.state';
import { CustomerActions, ECustomerActions } from '../actions/customer.actions';

export function customerReducer(state: CustomerInterfaceState = initialCustomerState, action: CustomerActions): CustomerInterfaceState {
  switch (action.type) {
    case ECustomerActions.GetCustomerSuccess: {
      // return state and data to save in store
      return { ...state, customer: action.payload };
    }

    case ECustomerActions.DeleteCustomerSuccess: {
      // return state and data to save in store
      return { ...state, customer: null };
    }

    case ECustomerActions.UpdatePasswordSuccess: {
      return { ...state };
    }

    case ECustomerActions.UpdatePasswordFailure: {
      return { ...state };
    }

    default:
      return state;
  }
};
